import gql from 'graphql-tag'

export default gql`
mutation deleteSiteServices($siteId: String!){
     deleteSiteServices(siteId: $siteId)
    }
`